export const getYoutubeId = url => {
  if (!url) return null;

  // Handle youtu.be short links
  if (url.includes('youtu.be/')) {
    const id = url.split('youtu.be/')[1]?.split(/[?&#]/)[0];
    return id && id.length === 11 ? id : false;
  }

  // Handle standard youtube.com URLs
  const regExp = /^.*(youtube\.com\/watch\?v=|youtube\.com\/embed\/|\/v\/|\/u\/\w\/|embed\/|watch\?v=|\?v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2] && match[2].length === 11 ? match[2] : false;
};
